import { useNavigate } from 'react-router-dom';
import { X, ShoppingCart, Minus, Plus, Trash } from '@phosphor-icons/react';
import { useCart } from '../../context/CartContext';
import { useUpsell } from '../../context/UpsellContext';
import { useStore } from '../../context/StoreContext';
import { getCategoryIcon } from '../../utils/categoryIcons';
import { insights } from '../../services/algoliaInsights';
import { recordEvent } from '../../utils/userProfile';
import { useTranslation } from 'react-i18next';

// Cart Dropdown Component
export const CartDropdown = () => {
  const { cartItems, removeFromCart, updateQuantity, getCartTotal, isCartOpen, setIsCartOpen } = useCart();
  const { hasAnyReadyUpsell } = useUpsell();
  const { selectedStore } = useStore();
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!isCartOpen) return null;

  const handleViewCart = () => {
    navigate('/cart');
    setIsCartOpen(false);
  };

  return (
    <div className="cart-dropdown-overlay" onClick={() => setIsCartOpen(false)}>
      <div className="cart-dropdown" onClick={(e) => e.stopPropagation()}>
        <div className="cart-dropdown-header">
          <h3>{t('cart')}</h3>
          <button className="cart-close" onClick={() => setIsCartOpen(false)}>
            <X size={20} />
          </button>
        </div>
        
        <div className="cart-dropdown-content">
          {cartItems.length === 0 ? (
            <div className="cart-empty">
              <ShoppingCart size={48} />
              <p>{t('no_results')}</p>
            </div>
          ) : (
            <>
              <div className="cart-items">
                {cartItems.map((item) => {
                  const storeData = item.store_data?.[`store_${(selectedStore || '1').toString().padStart(3, '0')}`];
                  const price = storeData?.price || item.price || 0;
                  const imageUrl = item.image ? (item.image.startsWith('http') ? item.image : `https:${item.image}`) : null;
                  const IconComponent = getCategoryIcon(item.categorias_flat);
                  
                  return (
                    <div key={item.objectID} className="cart-item">
                      <div 
                        className="cart-item-image" 
                        style={{ cursor: 'pointer', overflow: 'hidden' }}
                        onClick={() => {
                          insights.clickedObjectIDs('Cart Dropdown Product Click', 'saq_products', [item.objectID]);
                          recordEvent({ type: 'click', product: item });
                          navigate(`/produit/${item.objectID}`);
                          setIsCartOpen(false);
                        }}
                      >
                        {imageUrl ? (
                          <img src={imageUrl} alt={item.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        ) : (
                          <IconComponent size={32} color="#4B164C" />
                        )}
                      </div>
                      <div className="cart-item-details">
                        <h4 
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            insights.clickedObjectIDs('Cart Dropdown Product Click', 'saq_products', [item.objectID]);
                            recordEvent({ type: 'click', product: item });
                            navigate(`/produit/${item.objectID}`);
                            setIsCartOpen(false);
                          }}
                        >
                          {item.name}
                        </h4>
                        <p className="cart-item-price">${price.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</p>
                        <div className="cart-item-controls">
                          <button onClick={() => updateQuantity(item.objectID, item.quantity - 1)}>
                            <Minus size={14} />
                          </button>
                          <span>{item.quantity}</span>
                          <button onClick={() => updateQuantity(item.objectID, item.quantity + 1)}>
                            <Plus size={14} />
                          </button>
                          <button className="remove-btn" onClick={() => removeFromCart(item.objectID)}>
                            <Trash size={14} />
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="cart-dropdown-footer">
                {hasAnyReadyUpsell && (
                  <button
                    type="button"
                    onClick={handleViewCart}
                    style={{
                      width: '100%',
                      marginBottom: 10,
                      padding: '8px 10px',
                      fontSize: 12,
                      fontWeight: 600,
                      color: '#4B164C',
                      background: 'rgba(75, 22, 76, 0.08)',
                      border: '1px solid rgba(75, 22, 76, 0.15)',
                      borderRadius: 8,
                      cursor: 'pointer',
                    }}
                  >
                    {t('upsell.dropdown_hint')}
                  </button>
                )}
                <div className="cart-total">
                  <strong>{t('price')}: ${getCartTotal().toLocaleString('es-MX', { minimumFractionDigits: 2 })}</strong>
                </div>
                <button className="view-cart-btn" onClick={handleViewCart}>
                  {t('view_all')}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}; 